var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMigrateAsi = function SvgMigrateAsi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4BCD0",
    d: "M4.235 5.656a9.95 9.95 0 0 0-2.21 5.32h2.02c.18-1.46.76-2.79 1.62-3.9zm6.74-1.61v-2.02c-2.01.2-3.84 1-5.32 2.21l1.42 1.43a7.94 7.94 0 0 1 3.9-1.62m5.9 1.62 1.43-1.43a10 10 0 0 0-5.32-2.21v2.02c1.42.18 2.763.74 3.89 1.62m3.03 5.31h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.43c.86 1.1 1.44 2.43 1.62 3.89m-7.93 0h-5v2h5v4l5-5-5-5zm7.93 2h2.02c-.5 5.05-4.76 9-9.95 9s-9.45-3.95-9.95-9h2.02c.49 3.95 3.85 7 7.93 7s7.44-3.05 7.93-7"
  })));
};
export default SvgMigrateAsi;